import { fetchReducerFactory } from '../../../shared/store/fetchFactory';
import {
  FETCH_SCENARIOS_OPTIONS,
  FETCH_SCENARIO_MEMBERS_DATA,
  FETCH_COUNTRIES_FOR_SCENARIO,
  CLEAR_SCENARIO_MEMBERS_DATA,
} from './types';
import initialState from './initialState';


const fetchReducer = fetchReducerFactory(
  {
    [FETCH_SCENARIOS_OPTIONS]: 'Scenarios',
    [FETCH_SCENARIO_MEMBERS_DATA]: 'ScenarioMembersData',
    [FETCH_COUNTRIES_FOR_SCENARIO]: 'Countries',
  },
  initialState
);


const scenarioMembersReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_SCENARIO_MEMBERS_DATA: {
      return ({
        ...state,
        scenarioMembersData: initialState.scenarioMembersData,
      });
    }
    default: {
      return fetchReducer(state, action);
    }
  }
};

export default scenarioMembersReducer;
